import { Modal, Typography } from 'eezy-components'
import { Dispatch, SetStateAction } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import * as S from './styled'

type Props = {
  modalOpen: boolean
  setModalOpen: Dispatch<SetStateAction<boolean>>
}

/**
 * Interpolated translations:
 *
 * i18n-tasks-use t('enrollment.onboarding.popup.verification_blocked.info')
 */
const VerificationBlockedModal = ({ modalOpen, setModalOpen }: Props) => {
  const { t } = useTranslation()

  return (
    <Modal
      size="medium"
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      data-testid="id-verification-blocked-modal"
    >
      <Modal.Header>
        {t('enrollment.onboarding.popup.verification_blocked.title')}
      </Modal.Header>
      <Modal.Body>
        <S.Container>
          <Typography variant="body1">
            <Trans
              i18nKey={`enrollment.onboarding.popup.verification_blocked.info`}
              components={{
                url: (
                  <a
                    href="https://eezycontributors.zendesk.com/hc/en-us/requests/new"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </Typography>
        </S.Container>
      </Modal.Body>
    </Modal>
  )
}

export default VerificationBlockedModal
